import Text from '@components/Text';
import Colors from '@constants/Colors';
import { Popover, Typography, styled } from '@mui/material';
import { useState } from 'react';

const PremiumBadgeStyled = styled('span')(({ theme }) => ({
    color: Colors.PREMIUM,
}));

export const PremiumIcon = () => {
    return (
        <svg width="18" height="20" viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M4.84585 14.3896C4.76593 14.8691 4.72596 15.2355 4.72596 15.4886C4.72596 16.7807 4.92578 17.7465 5.32542 18.386C4.52614 18.9854 3.69356 19.2852 2.82767 19.2852C1.96179 19.2852 1.34235 19.0387 0.969351 18.5458C0.596354 18.0396 0.409856 17.2936 0.409856 16.3078C0.409856 15.3087 0.829477 12.4913 1.66872 7.85547L0.609676 5.7174C2.11498 4.74494 3.48708 4.25871 4.72596 4.25871C5.07232 4.25871 5.45197 4.32532 5.86493 4.45853C6.2779 4.57842 6.57096 4.7183 6.74414 4.87815C7.72992 4.49184 8.64243 4.29868 9.48167 4.29868C10.7339 4.29868 11.7197 4.73828 12.439 5.61749C13.1717 6.48337 13.538 7.53576 13.538 8.77464C13.538 10.2666 12.9985 11.5988 11.9195 12.771C11.3999 13.3438 10.7006 13.8034 9.82136 14.1498C8.94216 14.4961 8.04297 14.6693 7.1238 14.6693C6.21795 14.6693 5.45863 14.5761 4.84585 14.3896ZM5.22551 12.1116C5.41201 12.1516 5.60517 12.1716 5.80499 12.1716C6.65755 12.1716 7.41687 11.8718 8.08293 11.2724C8.749 10.6729 9.08203 9.93359 9.08203 9.05439C9.08203 8.44161 8.90219 7.92207 8.54252 7.49579C8.19616 7.06951 7.70328 6.85637 7.06385 6.85637C6.79743 6.85637 6.49104 6.90965 6.14468 7.01623C5.87826 8.84125 5.57187 10.5397 5.22551 12.1116Z"
                fill="currentColor"
            />
            <path
                d="M14.5442 0.439803C14.6749 0.108607 15.1436 0.108607 15.2743 0.439803L15.8456 1.88847C15.8855 1.98965 15.9656 2.06971 16.0668 2.10961L17.5154 2.6809C17.8466 2.81158 17.8466 3.28037 17.5154 3.41104L16.0668 3.98234C15.9656 4.02224 15.8855 4.1023 15.8456 4.20347L15.2743 5.65214C15.1436 5.98334 14.6749 5.98334 14.5442 5.65214L13.9729 4.20347C13.933 4.1023 13.8529 4.02224 13.7518 3.98234L12.3031 3.41104C11.9719 3.28037 11.9719 2.81158 12.3031 2.6809L13.7518 2.10961C13.8529 2.06971 13.933 1.98965 13.9729 1.88847L14.5442 0.439803Z"
                fill="currentColor"
            />
        </svg>
    );
};

export const PremiumBadge = () => {
    const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

    const handlePopoverOpen = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handlePopoverClose = () => {
        setAnchorEl(null);
    };

    const open = Boolean(anchorEl);

    return (
        <>
            <PremiumBadgeStyled
                aria-owns={open ? 'mouse-over-popover' : undefined}
                aria-haspopup="true"
                onMouseEnter={handlePopoverOpen}
                onMouseLeave={handlePopoverClose}>
                <PremiumIcon />
            </PremiumBadgeStyled>
            <Popover
                id="mouse-over-popover"
                sx={{
                    pointerEvents: 'none',
                }}
                open={open}
                anchorEl={anchorEl}
                PaperProps={{
                    sx: {
                        p: 2,
                        maxWidth: 300,
                        boxShadow: '0px 4px 80px 0px rgba(112, 144, 176, 0.14)',
                        borderRadius: 2,
                    },
                }}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'center',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'center',
                }}>
                <Text dark medium heading size={18}>
                    Offre Premium
                </Text>
                <Typography color={Colors.PRIMARY_PURPLE_50}>
                    Vous avez choisi de vous faire épauler par les équipes d'Upercut pour recruter votre futur Talent.
                </Typography>
            </Popover>
        </>
    );
};
